import React from "react";
import { Stack } from "@mui/material";

interface DividerComponentInterface {
  text?: string;
  mt?: string | number;
  mb?: string | number;
}
const DividerComponent = ({ text, mt, mb }: DividerComponentInterface) => {
  return (
    <Stack
      mt={mt}
      mb={mb}
      width="100%"
      height="1px"
      borderBottom={(theme: any) =>
        `1px solid ${theme.palette.common.borderGrey}`
      }
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {text ? (
        <span
          style={{
            backgroundColor: "#F9F9F9",
            padding: "0 10px",
          }}
        >
          {text}
        </span>
      ) : null}
    </Stack>
  );
};
export default DividerComponent;
